import { Injectable } from '@angular/core';
import { HubConnectionState } from '@microsoft/signalr';
import { SignalRNotificacaoService } from '../../../../@theme/components/notificacoes/service/signalr-notificacao.service';
import { PresencaEscritorioDataService } from './PresencaEscritorioController/presenca-escritorio-data.service';

@Injectable({
  providedIn: 'root'
})
export class PresencaEscritorioColetaService {
  private iniciado = false;
  private ultimaColeta = 0;

  constructor(
    private hub: SignalRNotificacaoService,
    private presencaData: PresencaEscritorioDataService
  ) { }

  iniciar(): void {
    this.garantirAssinatura();
    this.coletar(true);
  }

  private garantirAssinatura(): void {
    if (this.iniciado) {
      return;
    }
    this.iniciado = true;
    this.hub.solicitarLocalizacao$.subscribe(() => this.coletar());
    this.hub.connectionState$.subscribe(estado => {
      if (estado === HubConnectionState.Connected) {
        this.coletar();
      }
    });
  }

  private coletar(forcar = false): void {
    const agora = Date.now();
    if (forcar) {
      if (agora - this.ultimaColeta < 3000) {
        return;
      }
    } else if (agora - this.ultimaColeta < 30000) {
      return;
    }
    if (!navigator.geolocation) {
      return;
    }

    this.ultimaColeta = agora;
    navigator.geolocation.getCurrentPosition(
      posicao => this.enviar(posicao),
      () => {
        navigator.geolocation.getCurrentPosition(
          posicao => this.enviar(posicao),
          () => undefined,
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 60000 }
        );
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  }

  private enviar(posicao: GeolocationPosition): void {
    const coords = posicao.coords;
    this.presencaData.RegistrarLocalizacao(
      coords.latitude,
      coords.longitude,
      coords.accuracy ?? null
    ).subscribe(
      () => undefined,
      () => undefined
    );
  }
}
